/** @format */

// import 'babel-polyfill'
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'mobx-react';
import * as stores from 'config/Stores';
import { HashRouter as Router } from 'react-router-dom';

// 使用PWA时开启
// import * as OfflinePluginRuntime from 'offline-plugin/runtime';

import App from 'widget/App/AppView';
import { LocaleProvider } from 'antd';
import 'utils/base';

import { IntlProvider, addLocaleData } from 'react-intl'; //多语言方案
//静态内容语言配置
import staticLabelLanguage from 'config/langs';

import Config from 'config/Config';

//内置组件语言配置
import zhCN from 'antd/lib/locale-provider/zh_CN';
import enUS from 'antd/lib/locale-provider/en_US';

import { WidgetConfig } from 'yx-widget';
import  yxWidgetTc  from 'config/langs/tc/yxWidgetTc'
// 云徙组件配置
WidgetConfig.set({
  languageEnv: Config.languageEnv,
  dynamicForm: {
    labelLength: Config.languageEnv == 'enUS' ? 14 : 6
  },
  table:{
    // btnVertical: 'panel',
    authority: true,
    noPanel: true
  },
  request:{
    message: false
  },
  iconFontUrls: {
    yxWidget: Config.iconFontUrls || "//at.alicdn.com/t/font_2420032_x8lvfwhqpzh.js", //'//at.alicdn.com/t/font_1643396_n26v76q19w.js'
  },
});
WidgetConfig.setLanguage({
  zhCN: {
    YxSearchPanel: {
      ht: '查询条件'
    }
  },
  tc: yxWidgetTc
});

// 设置全局app对象
window.app = {};

let languagePackage = {
  zhCN: zhCN,
  enUS: enUS
}[Config.languageEnv];

// 渲染到DOM ID为app的节点上
ReactDom.render(
  <LocaleProvider locale={languagePackage}>
    {/*多语言组件,locale的值是国际化组件内置配置的，如果用不到内置内容，可以设置为en*/}
    <IntlProvider locale='en' messages={staticLabelLanguage}>
      <Provider {...stores}>
        <App />
      </Provider>
    </IntlProvider>
  </LocaleProvider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js